<template>
  <div class="rj-page-card">
    <!-- <div class="rj-page-card__title">电汇查询</div> -->
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="业务实体:" prop="bussinessEntity">
          <el-select v-model="searchForm.bussinessEntity" placeholder="请选择" clearable>
            <el-option v-for="option in businessNameList" :key="option.name" :label="option.name" :value="option.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="收款编号:" prop="telegraphicTransferNum">
          <el-input v-model.trim="searchForm.telegraphicTransferNum" placeholder="请输入收款编号" />
        </el-form-item>
        <el-form-item label="净收款额:" prop="amountCollectedLeftEndpoint">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-input v-model="searchForm.amountCollectedLeftEndpoint" placeholder="请输入" />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <el-form-item prop="amountCollectedRightEndpoint">
              <div class="rj-flex__item">
                <el-input v-model="searchForm.amountCollectedRightEndpoint" placeholder="请输入" />
              </div>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="收款日期:" prop="arrivalMoneyStartDate">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.arrivalMoneyStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.arrivalMoneyEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="银行名称:" prop="openBankName">
          <el-select v-model="searchForm.openBankName" placeholder="请选择" clearable @focus="onBankList">
            <el-option v-for="option in list" :key="option.value" :label="option.value" :value="option.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款客户名称:" prop="importCompany">
          <el-select v-model="searchForm.importCompany" filterable placeholder="请输入付款客户名称" style="width:160px;margin: 0 10px;" remote :remote-method="remoteMethod" clearable>
            <el-option
              v-for="item in customerOptions"
              :key="item.finalCustomerID"
              :label="item.finalCustomerName"
              :value="item.finalCustomerName"
              :loading="loading"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款单已生成:" prop="isReceipt">
          <el-select v-model="searchForm.isReceipt" placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否废弃行:" prop="isDelete">
          <el-select v-model="searchForm.isDelete" placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="已分配:" prop="isAssigned">
          <el-select v-model="searchForm.isAssigned" placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户是否存在ERP:" prop="isErpHas">
          <el-select v-model="searchForm.isErpHas" placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建类型:" prop="dataType">
          <el-select v-model="searchForm.dataType" placeholder="请选择" clearable>
            <el-option v-for="item in dataTypeOptions" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:" prop="createTime">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="退款状态:" prop="isRefund">
          <el-select v-model="searchForm.isRefund" placeholder="请选择" clearable>
            <el-option v-for="item in refundOptions" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="doSearch">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm('searchForm')">
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <div style="margin: 20px 0">
        <div v-if="this.$store.state.enumeration.telegraphicTransferAuth.includes(this.$store.state.user.userId)" style="float:left; margin-right:10px">
          <!-- <el-button type="primary" @click="Abandoned">废弃勾选的来款单</el-button> -->
          <el-select v-model="name" filterable placeholder="请输入修改客户名称" style="width:200px;margin: 0 10px;" remote :remote-method="remoteMethod">
            <el-option
              v-for="item in customerOptions"
              :key="item.finalCustomerID"
              :label="item.finalCustomerName"
              :value="item.finalCustomerName"
              :loading="loading"
            />
          </el-select>

          <el-button type="primary" @click="editCustomer">
            修改客户
          </el-button>
        </div>
        <div>
          <el-select
            v-model="incomingPaymentSummary"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in incomingPaymentSummaryArray"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
          <el-button type="primary" style="margin-left:10px" :loading="isLoading" @click="changeSummary">
            修改收款大类
          </el-button>
          <el-button v-if="!isStop && !perssimionCodeList.includes('businessWireTransferList')" type="default" style="margin-left:10px" :loading="isLoading" @click="stop">
            暂停系统分配功能
          </el-button>
          <el-button v-if="isStop && !perssimionCodeList.includes('businessWireTransferList')" type="default" style="margin-left:10px" :loading="isLoading" @click="open">
            启用系统分配功能
          </el-button>
        </div>

        <!-- <div class="rj-page-card__content" v-if="this.$store.state.enumeration.telegraphicTransferAuth.includes(this.$store.state.user.userId)"> -->
        <!-- <el-button type="primary" @click="importVisible=true">导入来款记录</el-button> -->
        <!-- </div> -->
      </div>
      <div v-loading="tableLoading" class="tableBody">
        <div class="operate-btn-wrap">
          <el-button type="primary" @click="createOrder">
            生成收款单
          </el-button>
          <el-button type="default" :loading="submitLoading" @click="exportExcel">
            按条件导出
          </el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" select="" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" fixed="left" />
          <el-table-column prop="bussinessEntity" label="业务实体" fixed="left" align="left" />
          <el-table-column prop="openBankName" label="银行名称" align="left" width="180" />
          <el-table-column prop="arrivalMoneyDate" label="收款日期" align="left" width="120" />
          <el-table-column prop="telegraphicTransferNum" label="收款编号" align="left" width="190">
            <template v-slot="{row}">
              <el-button type="text" class="el-btn-text-left" @click="showDetail(row)">
                {{ row.telegraphicTransferNum }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="remittanceAmount" label="收款总额" align="right" header-align="left" width="110" />
          <el-table-column prop="actualRemittanceAmount" label="净收款额" align="right" header-align="left" width="110" />
          <el-table-column prop="unusedAmount" label="可用余额" align="right" header-align="left" width="110" />
          <el-table-column prop="serviceFee" label="手续费" align="right" header-align="left" width="110" />
          <el-table-column prop="currency" label="币种" align="left" />
          <el-table-column prop="importCompany" label="原始客户名称" align="left" width="180" />
          <el-table-column prop="newImportCompany" label="修改后客户" align="left" width="110" />
          <el-table-column prop="isErpHas" label="客户是否存在ERP" align="left" width="130">
            <template v-slot="{row}">
              <span v-if="row.isErpHas">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="isAssigned" label="是否已分配" align="left" width="90">
            <template v-slot="{row}">
              <span v-if="row.isAssigned">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="summary" label="来款摘要" align="left" min-width="120" />
          <el-table-column prop="isReceipt" label="已生成收款单" align="left" width="100">
            <template v-slot="{row}">
              <span v-if="row.isReceipt">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="collectionCategories" label="收款大类" align="left" />
          <el-table-column prop="isDelete" label="是否已废弃" align="left" width="90">
            <template v-slot="{row}">
              <span v-if="row.isDelete">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="financeState" width="170" label="状态" align="left">
            <template v-slot="{row}">
              <span>{{ row.financeState }}</span>
            </template>
          </el-table-column>
          <!-- 判断是否商务 -->
          <el-table-column label="操作" width="210" align="left" fixed="right">
            <template v-slot="{row}">
              <template v-if="isShowFreeze">
                <el-button v-if="row.freezeStatus" type="text" class="freeze-btn" @click="thawPaymentReceipt(row)">
                  解冻
                </el-button>
                <el-button v-if="!row.freezeStatus" type="text" class="freeze-btn" @click="freezePaymentReceipt(row)">
                  冻结
                </el-button>
              </template>

              <span v-if="!row.isDelete">
                <el-button v-if="row.rebuild === null" type="text" @click="nullifyReceipt(row)">作废来款单</el-button>
                <template v-if="perssimionCodeList.includes('businessWireTransferList')">
                  <el-button v-if="row.state==='修改客户'&&!row.isReceipt &&!row.isAssigned" type="text" @click="change(row)">修改客户</el-button>
                  <el-button v-if="row.state==='编辑客户' || row.state==='召回'" type="text" @click="edit(row)">编辑客户</el-button>
                  <el-button v-if="row.state==='编辑客户' || row.state==='召回'" type="text" @click="noChange(row)">放弃修改客户</el-button>
                  <el-button v-if="row.state==='待领导审核' || row.state==='待财务审核'" type="text" class="recall-btn" @click="handleRecall(row)">召回客户名称修改</el-button>
                  <el-button v-if="!row.isDelete" type="text" @click="refund(row)">申请退款</el-button>
                  <el-button v-if="!row.isDelete && !row.isAssigned" type="text" @click="toAllocation(row)">分配</el-button>
                </template>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </div>
    <el-dialog title="电汇底单详细信息" :visible.sync="financeremListVisible" width="800px">
      <financeremittance-detail-box v-if="financeremListVisible" :id="telegraphicTransferNumID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="financeremListVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="电汇底单详细信息" :visible.sync="remittanceVisible" width="800px">
      <financeremittance-info-box v-if="remittanceVisible" :id="telegraphicTransferNumID" @close="changeApplyVisible" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="remittanceVisible = false">关 闭</el-button>
        <el-button type="primary" @click="confirmApplyForRefund">确 认</el-button>
      </span>
    </el-dialog>
    <!-- 操作 -> 作废来款单 -->
    <el-dialog v-if="nullifyReceiptVisible" title="作废来款单" :visible.sync="nullifyReceiptVisible" width="800px" @close="nullifyReceiptClose">
      <span style="margin-right:5px">作废类型：<span style="color:red">*</span> </span>
      <el-radio v-model="radio" label="1">
        委托付款
      </el-radio>
      <el-radio v-model="radio" label="0">
        认款主档错误
      </el-radio>
      <div style="color:red">
        说明：委托付款：指A公司（销售）帮B公司（直接客户）付款分配后，B公司又付款给我司，商务申请作废后，财务会重新抛A公司的来款到CES，商务/渠道可以申请实际退款到A公司或不退款A公司用于其他订单；
        <br>
        认款主档数据错误：指来款不应该是销售订单的款被分配到了销售订单上，在没有开发货单的前提下，商务申请作废财务审批后，这笔电汇单作废且不再重新推送来款到CES，电汇单对应的分配记录将全部取消。
      </div>
      <div style="margin:10px 0 10px 0">
        作废原因 <span style="color:red">*</span>
      </div>
      <el-input v-model="fileDetail" type="textarea" maxlength="100" style="margin:0 0 10px 0" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="cancel">取消申请</el-button>
        <el-button type="primary" :loading="nullifyReceiptLoading" @click="nullifySubmit">提交申请</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改客户名称" :visible.sync="changeName" width="800px" @close="changeClose">
      <changeName ref="changeName" :row-data="changeData" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="changeName = false">关 闭</el-button>
        <el-button type="primary" :loading="isLoadingChangeSure" @click="sureChange">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑客户名称" :visible.sync="editName" width="800px" @close="editClose">
      <editName v-if="editName" ref="editName" :row-data="changeData" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="editName = false">关 闭</el-button>
        <el-button type="primary" :loading="isLoadingEditSure" @click="editSure">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="退款" :visible.sync="applyVisible" width="800px">
      <remittance-apply-box v-if="applyVisible" :id="remittanceInfoID" :currency="refundCurrency" @close="changeApplyVisibleCopy" @set-loading="(isTrue) => isSubmitCLoading = isTrue" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyVisible = false">取 消</el-button>
        <el-button type="primary" :loading="isSubmitCLoading" @click="submitApply">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="召回" :visible.sync="recallVisible" width="600px" @close="handleRecallClose">
      <el-form ref="recallForm" :model="recallForm" :rules="recallRules" label-width="80px">
        <el-form-item label="召回理由" prop="reason">
          <el-input
            v-model="recallForm.reason"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入召回理由"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleRecallClose">关 闭</el-button>
        <el-button type="primary" @click="handleRecallConfirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
import financeremittanceInfoBox from './FinanceremittanceInfoBox';
import financeremittanceDetailBox from './FinanceremittanceDetailBox';
import remittanceApplyBox from './remittanceApplyBox.vue';
// import importRemittance from './importRemittance';
import { selectTelegraphicTransferList, financialCancellationTransfer, updateImportCompanyByPrimaryKey, createReceipt, getFinalCustomerInfoList, getDictData, updateSystemAssignFunction, batchUpdateTelSummary, modifyCustomerName, telApprovalEdit, undoDistributionAgree, scrapReceipt, checkApplyCount, updateTransferFreeze, recallCustomerNameModify } from '@/API/index';
import eventBus from '@/libs/eventBus';
import axios from '@/API';
import changeName from './changeName';
import editName from './editName';
import { formatDate } from '@/libs/util.js';
import { checkExportCompliance } from '@/libs/exportCompliance';
export default {
  data () {
    return {
      userList: ['R02400', 'R16877', 'R24192', 'W01687'],
      nullifyReceiptVisible: false,
      fileDetail: '',
      radio: '1',
      options: [
        {
          value: '-1',
          label: '全部'
        }, {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
      dataTypeOptions: [
        {
          value: '-1',
          label: '全部'
        }, {
          value: '1',
          label: '财务导入'
        }, {
          value: '0',
          label: '银企直连'
        }],
      refundOptions: [
        {
          value: '0',
          label: '全部'
        }, {
          value: '1',
          label: '退款中'
        }, {
          value: '2',
          label: '退款完成'
        }
      ],
      searchForm: {
        bussinessEntity: '',
        arrivalMoneyStartDate: '',
        arrivalMoneyEndDate: '',
        importCompany: '',
        account: '',
        isReceipt: '-1',
        isDelete: '0',
        isAssigned: '-1',
        isErpHas: '-1',
        dataType: '-1',
        createTime: '',
        telegraphicTransferNum: '',
        openBankName: '',
        amountCollectedLeftEndpoint: '',
        amountCollectedRightEndpoint: ''
      },
      name: '',
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      remittanceInfoID: '',
      refundCurrency: '',
      remittanceVisible: false,
      importVisible: false,
      multipleSelection: [],
      telegraphicTransferNumID: '', // 查询退款详情的时候
      financeremListVisible: false, // 查看电汇信息详情
      customerOptions: [],
      loading: false,
      list: [],
      submitLoading: false,
      incomingPaymentSummary: '',
      incomingPaymentSummaryArray: [],
      sysAssignFunctionValue: '',
      sysAssignFunction: [],
      isLoading: false,
      isStop: false, // 是否开启分配
      changeName: false, // 修改客户名称
      editName: false,
      changeData: {},
      isLoadingChangeSure: false,
      isLoadingEditSure: false,
      postData: {},
      nullifyReceiptLoading: false,
      transferNum: '',
      applyVisible: false,
      isSubmitCLoading: false,
      recallVisible: false,
      recallForm: { reason: '' },
      recallRules: {
        reason: [{ required: true, message: '输入信息不可为空', trigger: 'blur' }]
      },
      recallRow: null
    };
  },
  components: {
    financeremittanceInfoBox,
    financeremittanceDetailBox,
    changeName,
    editName,
    remittanceApplyBox
    // importRemittance
  },
  computed: {
    ...mapState({
      businessNameList: state => state.enumeration.businessNameList, //  业务实体列表-来款记录查询(财务)
      importCompanyList: state => state.enumeration.importCompanyList, //  银行账号信息列表-来款记录查询(财务)
      getBankInfoList: state => state.enumeration.getBankInfoList, // 根据供货单位ID获取银行列表
      perssimionCodeList: state => state.user.perssimionCodeList, // 登录权限
      userInfo: state => state.user
    }),

    // 冻结解冻只有“江俊寿”和“林锦茵”有权限，通过id判断
    isShowFreeze () {
      return this.userList.includes(this.userInfo?.userId);
    }
  },
  methods: {
    ...mapActions('enumeration', [
      'initBusinessNameList',
      'initImportCompanyList',
      'getBankInfo'
    ]),
    toAllocation (row) {
      this.$router.push({ name: 'orderClerkWireTransferAllocation', query: { teleNum: row.telegraphicTransferNum } });
    },
    initData () {
      let parmas = ['incoming_payment_summary', 'sys_assign_function'];
      getDictData(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          // 下拉列表基础数据
          json.data.forEach((item) => {
            if (item.dictType === 'incoming_payment_summary') {
              this.incomingPaymentSummaryArray = item.dictDataVOS;
            }
            if (item.dictType === 'sys_assign_function') {
              this.sysAssignFunction = item.dictDataVOS;
              this.sysAssignFunctionValue = item.dictDataVOS[0].dictValue;
              if (this.sysAssignFunctionValue === '暂停系统分配功能') {
                this.isStop = true;
              } else {
                this.isStop = false;
              }
            }
          });
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    doSearch () {
      this.currentPage = 1;
      this.financeremList();
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.arrivalMoneyEndDate = '';
      this.searchForm.isDelete = '-1';
      this.financeremList();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.financeremList();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.financeremList();
    },
    showDetail (row) {
      this.telegraphicTransferNumID = row.telegraphicTransferNum;
      this.financeremListVisible = true;
    },
    showInfo (row) {
      this.remittanceVisible = true;
      this.telegraphicTransferNumID = row.telegraphicTransferNum;
    },
    handleSelectionChange (rows) {
      rows.forEach(row => {
        if (row.isDelete) {
          this.$refs.multipleTable.toggleRowSelection(row, false);
          this.$notify.warning('已废弃不能进行其他操作');
        }
      });
      this.multipleSelection = rows;
    },
    Abandoned () {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择至少一条电汇单');
        return;
      }
      let teleNum = [];
      // let error = '';
      this.multipleSelection.forEach((item) => {
        // if (item.isReceipt) {
        //   error = '选择中已经生成收款单不能废弃';
        //   return;
        // }
        teleNum.push(item.telegraphicTransferNum);
      });
      // if (error) {
      //   this.$notify.warning(error);
      //   return;
      // }

      this.$confirm('是否废弃选中的来款单?', '提示', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        financialCancellationTransfer(teleNum).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('废弃勾选来款单成功');
            this.financeremList();
          }
        }).catch((res) => {

        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消废弃'
        });
      });
    },
    async editCustomer () {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择至少一条电汇单');
        return;
      }
      if (!this.name) {
        this.$message.warning('请输入客户名称');
        return;
      }
      let list = [];
      this.multipleSelection.forEach((item) => {
        let ls = {};
        ls.telegraphicTransferNum = item.telegraphicTransferNum;
        ls.newImportCompany = this.name;
        list.push(ls);
      });
      this.tableLoading = true;
      const decision = await checkExportCompliance(this, {
        businessScene: 'TT_CUSTOMER_NAME_UPDATE',
        originalBizId: list.length === 1 ? list[0].telegraphicTransferNum : null,
        subjectNameList: [this.name]
      });
      if (!decision.allowBusiness) {
        this.tableLoading = false;
        return;
      }
      updateImportCompanyByPrimaryKey(list).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('修改公司名字成功');
          this.name = '';
          this.financeremList();
          this.tableLoading = false;
        }
        this.tableLoading = false;
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    // 生成收款单
    createOrder () {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择至少一条电汇单');
        return;
      }
      let teleNum = [];
      this.multipleSelection.forEach((item) => {
        teleNum.push(item.telegraphicTransferNum);
      });
      createReceipt(teleNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('生成收款单成功');
          this.financeremList();
        }
      }).catch((res) => {

      });
    },
    financeremList () {
      this.tableLoading = true;
      selectTelegraphicTransferList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
          this.tableLoading = false;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    createReceipts () {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择至少一条电汇单');
        return;
      }
      createReceipt().then((res) => {

      }).catch((res) => {

      });
    },
    // 获取最终客户
    getFinalCustomerInfo () {
      getFinalCustomerInfoList(this.name || '').then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.customerOptions = json.data;
        }
      }).catch((res) => {

      });
    },
    // 输入文字获取最终客户名称
    remoteMethod (query) {
      if (query !== '') {
        getFinalCustomerInfoList(query).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.customerOptions = json.data.find(row => row.finalCustomerName === query) ? json.data : [{ finalCustomerID: query, finalCustomerName: query }, ...json.data];
            console.log(json.data);
          }
        }).catch((res) => {

        });
      }
    },
    // 财务确认是否同意退款申请
    confirmApplyForRefund () {
      eventBus.$emit('confirmApply');
      // this.remittanceVisible = false;
    },
    changeApplyVisible () {
      this.remittanceVisible = false;
      this.financeremList();
    },
    nullifyReceiptClose () {
      this.nullifyReceiptVisible = false;
      this.fileDetail = '';
      this.radio = '1';
    },
    refreshData () {
      this.financeremList();
    },
    onBankList () {
      this.list = this.getBankInfoList.map(item => {
        return { value: item, label: item };
      });
    },
    noChange (row) {
      this.$confirm('您确定要放弃修改来款客户名称吗？放弃修改后将不可再次申请修改来款客户名称', '友情提示', {
        confirmButtonText: '放弃修改',
        cancelButtonText: '返回继续修改',
        type: 'warning'
      }).then(() => {
        scrapReceipt(row.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('修改客户成功');
            this.doSearch();
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },
    /**
     * 召回客户名称修改申请
     * @param {*} row 电汇详情
     */
    handleRecall (row) {
      this.recallRow = row;
      this.recallVisible = true;
    },
    handleRecallClose () {
      this.$refs.recallForm.resetFields();
      this.recallRow = null;
      this.recallVisible = false;
    },
    handleRecallConfirm () {
      this.$refs.recallForm.validate(valid => {
        if (valid) {
          // 后续填充
          const param = {
            id: this.recallRow.telApprovalId,
            telId: this.recallRow.id,
            opinion: this.recallForm.reason
          };
          recallCustomerNameModify(param).then((res) => {
            const json = res.data;
            if (json.status === '200') {
              this.$message.success('召回成功');
              this.handleRecallClose();
              this.doSearch();
            }
          });
        }
      });
    },
    exportExcel () {
      this.submitLoading = true;
      this.currentPage = 1;
      axios.post('/TelegraphicTransfer/exportTeleExcel', { ...this.searchForm, pageIndex: this.page.currentPage, pageSize: this.page.pageSize }, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        let date = new Date();
        date = formatDate(date, 'yyyy-MM-dd');
        const fileName = '电汇列表' + date + '.xlsx';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    // 修改来款摘要
    changeSummary () {
      let multipleSelection = this.multipleSelection;
      if (multipleSelection.length === 0) {
        this.$message.error('请勾选电汇信息');
        return;
      }
      let data = [];
      multipleSelection.forEach((item, index) => {
        data[index] = item.telegraphicTransferNum;
      });
      let parmas = {
        summary: this.incomingPaymentSummary,
        telNums: data
      };
      this.isLoading = true;
      batchUpdateTelSummary(parmas).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('修改收款大类成功');
          this.doSearch();
        }
      }).catch((res) => {

      });
    },
    open () {
      this.$confirm('启用系统分配功能后，所有人将可以进行款的分配，您确定要启用分配功能吗？', '提示', {
        confirmButtonText: '启用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isLoading = true;
        updateSystemAssignFunction().then((res) => {
          this.isLoading = false;
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('开启成功');
            this.initData();
          }
        }).catch((res) => {

        });
      }).catch(() => {
        this.isLoading = false;
      });
    },
    stop () {
      this.$confirm('暂停系统分配功能后，所有人将无法进行款的分配，您确定要暂停分配功能吗？', '', {
        confirmButtonText: '暂停',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isLoading = true;
        updateSystemAssignFunction().then((res) => {
          this.isLoading = false;
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('暂停成功');
            this.initData();
          }
        }).catch((res) => {
          this.isLoading = false;
        });
      }).catch(() => {
        this.isLoading = false;
      });
    },
    nullifyReceipt (row) {
      this.postData.ids = [row.id];
      this.transferNum = row.telegraphicTransferNum;
      this.nullifyReceiptVisible = true;
    },
    nullifySubmit () {
      if (!this.fileDetail) {
        this.$message.error('作废原因不能为空');
        return false;
      }
      this.postData.type = 2;
      this.postData.reason = this.fileDetail;
      this.postData.rebuild = parseInt(this.radio);
      let isBussiness = this.perssimionCodeList.includes('businessWireTransferList');
      this.nullifyReceiptLoading = true;
      if (isBussiness) {
        undoDistributionAgree(this.postData).then((res) => {
          this.nullifyReceiptLoading = false;
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '作废成功'
            });
            this.doSearch();
            this.nullifyReceiptClose();
          }
        }).catch(() => {
          this.nullifyReceiptLoading = false;
        });
      } else {
        financialCancellationTransfer({ transferNum: this.transferNum, transferOpinion: this.fileDetail, rebuild: parseInt(this.radio) }).then((res) => {
          this.nullifyReceiptLoading = false;
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '作废成功'
            });
            this.doSearch();
            this.nullifyReceiptClose();
          }
        }).catch(() => {
          this.nullifyReceiptLoading = false;
        });
      }
    },
    cancel () {
      this.nullifyReceiptClose();
    },
    change (row) {
      this.changeName = true;
      this.changeData = row;
    },
    edit (row) {
      this.editName = true;
      this.changeData = row;
    },
    // 确认编辑
    async editSure () {
      let newName = this.$refs.editName.newName;
      if (newName === '') {
        this.$message.error('请输入修改后客户名称');
        return;
      }
      let parmas = {
        id: this.changeData.telApprovalId,
        newImportCompany: this.$refs.editName.newName,
        fileList: this.$refs.editName.fileList
      };
      this.isLoadingEditSure = true;
      const decision = await checkExportCompliance(this, {
        businessScene: 'TEL_APPROVAL_EDIT',
        originalBizId: String(parmas.id || ''),
        subjectNameList: [parmas.newImportCompany]
      });
      if (!decision.allowBusiness) {
        this.isLoadingEditSure = false;
        return;
      }
      telApprovalEdit(parmas).then((res) => {
        this.isLoadingEditSure = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('编辑成功');
          this.editClose();
          this.doSearch();
        } else {

        }
      }).catch(() => {
        this.isLoadingEditSure = false;
      });
    },
    // 确认修改
    async sureChange () {
      let newName = this.$refs.changeName.newName;
      if (newName === '') {
        this.$message.error('请输入修改后客户名称');
        return;
      }
      let parmas = [{
        telId: this.changeData.id,
        newImportCompany: this.$refs.changeName.newName,
        fileList: this.$refs.changeName.fileList
      }];
      this.isLoadingChangeSure = true;
      const decision = await checkExportCompliance(this, {
        businessScene: 'TEL_APPROVAL_MODIFY',
        subjectNameList: [newName]
      });
      if (!decision.allowBusiness) {
        this.isLoadingChangeSure = false;
        return;
      }
      modifyCustomerName(parmas).then((res) => {
        this.isLoadingChangeSure = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('提交成功');
          this.changeClose();
          this.doSearch();
        } else {

        }
      }).catch(() => {
        this.isLoadingChangeSure = false;
      });
    },
    // 修改关闭
    changeClose () {
      this.$refs.changeName.newName = '';
      this.$refs.changeName.fileList = [];
      this.changeName = false;
    },
    // 编辑关闭
    editClose () {
      this.$refs.editName.newName = '';
      this.$refs.editName.fileList = [];
      this.editName = false;
    },
    async refund (row) {
      let ischeck = 'true';
      let res = await checkApplyCount(row.telegraphicTransferNum);
      let json = res.data;
      if (json.status === '200') {
        ischeck = json.data;
      } else {
        this.$message.warning('接口发生错误');
        return false;
      }

      if (ischeck === 'true') {
        this.remittanceInfoID = row.telegraphicTransferNum;
        this.refundCurrency = row.currency || '';
        this.applyVisible = true;
      } else {
        this.$message.warning('已经申请过退款');
      }
    },
    // 确认提交退款信息
    submitApply () {
      eventBus.$emit('submitApplyInfo');
    },
    changeApplyVisibleCopy (val) {
      this.applyVisible = val;
      this.doSearch();
    },

    // 冻结来款单
    freezePaymentReceipt ({ id, freezeStatus }) {
      this.$confirm('冻结来款单后，电汇单将无法分配，您确定要冻结此来款单吗？', {
        confirmButtonText: '冻结',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.toggleFreeze({ id, freezeStatus });
        })
        .catch(() => {});
    },

    // 解冻来款单
    thawPaymentReceipt ({ id, freezeStatus }) {
      this.$confirm('解冻来款单后，电汇单将可以进行分配，您确定要解冻此来款单吗？', {
        confirmButtonText: '解冻',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.toggleFreeze({ id, freezeStatus });
        })
        .catch(() => {});
    },

    // 切换冻结和解冻
    toggleFreeze ({ id, freezeStatus }) {
      let params = { id, freezeStatus: !freezeStatus };
      updateTransferFreeze(params).then(res => {
        let { status, err } = res.data;
        if (status === '200') {
          this.financeremList();
          this.$message.success(err);
        }
      });
    }
  },
  mounted () {
    this.initBusinessNameList();
    this.getBankInfo();
    this.financeremList();
    this.getFinalCustomerInfo();
    this.initData();
  }
};
</script>
<style scoped lang="scss">
.freeze-btn{
  margin-right: 6px;
}

.recall-btn{
  color: #F56C6C;
}
</style>
